import { createStore, applyMiddleware } from 'redux';
import axios from 'axios';
import axiosMiddleware from 'redux-axios-middleware';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducers from './configureReducers';
import thunk from "redux-thunk";
import { APP_BASE_API_URL} from "../Utils/enviromentApp.js";

//import { setError } from "../store/ducks/duckError.js";

const BAD_REQUEST_CODE=400
const SERVER_ERROR_REQUEST_CODE=500

export default function configureStore(initialState = {}) //, bearerToken, appInsights
{
    const composeEnhancers = composeWithDevTools({});
    
    const axiosInit = { 
      baseURL: APP_BASE_API_URL,//process.env.NODE_ENV === 'development' ? APP_BASE_API_URL : '/App/',
      withCredentials: true,
      //mode: 'cors'
    }
    const middlewareConfig = {

        onError({ dispatch, error }) {
            const {response} = error;
            const message = error.message ?? "Request error";
    

           if(response?.status === BAD_REQUEST_CODE ?? false)
           {
               //const title = response.data.title;
               /*const detail = response.data.errors?.Description[0] ?? title;*/
               

            //dispatch(setError(message,title,detail))

           }else if(response?.status === SERVER_ERROR_REQUEST_CODE ?? false)
           {
            const title = response.data.title;
            const detail = error.response?.data?.error ? error.response?.data.error[0]:error.response?.data.detail;
           // dispatch(setError(message,title,detail)) 
         

           }
           else{
            const title = response?.data.title ?? error.message;
            const detail = response?.statusText ?? error.stack;
            //dispatch(setError(message,title,detail)) 
          
           }
           
           return Promise.reject(error)
        }


    };
    
        const axiosInstance = axios.create(axiosInit);
        axiosInstance.interceptors.request.use(function(config){
            return config;
        },function (error) {
            console.log('ErrI1rq',error)

            return Promise.reject(error);
        }
        );

           axiosInstance.interceptors.response.use(function (config) {
            return config;
        }, function (error) {
            console.log('ErrI1rp',error)

            if (error.response.status === SERVER_ERROR_REQUEST_CODE){
                const {status, requestId, traceIdentifier} = error.response.data;
                window.location.href = `/Home/Error?StatusCode=${status}&RequestId=${requestId}&TraceIdentifier=${traceIdentifier}&ExType=${error}&ExMessage=${error.response.data.error}`;
            }

            return Promise.reject(error);
        })
    const middleware = [thunk, axiosMiddleware(axiosInstance,  middlewareConfig)];
    const store = createStore(reducers, initialState, composeEnhancers(applyMiddleware(...middleware)));
    return store;
};